module.exports = __webpack_public_path__ + "0bff33a5fd7ec390235476b4859747a0.ttf";